import makeStyles from "@mui/styles/makeStyles";

export const exerciseLibraryStyles = makeStyles((theme) => ({
  root: {},

  subText: {
    color: theme.palette.text.secondary,
    fontWeight: "normal",
    hyphens: "auto",
    hyphenateCharacter: "auto",
    wordBreak: "break-word",
  },
  tags: {
    "&.MuiBox-root": { m: 0 },
    width: "fit-content",
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0.8, 1.5),
    "& > *": {
      fontSize: 12,
    },
  },
  thumbnailList: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    flexWrap: "wrap",
  },
  category: {
    padding: theme.spacing(0.8, 1.5),
    "& > *": {
      fontSize: 12,
    },
  },
  mobileCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[1],
  },
  defaultOption: {
    borderColor: theme.palette.grey[300],
    transition: "background-color 0.3s ease, border-color 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.grey[200],
      cursor: "pointer",
    },
  },

  editorLabel: {
    color: theme.palette.text.secondary,
    fontSize: 16,
  },

  badgeCategoryTag: {
    height: 36,
    padding: theme.spacing(0.7, 1.5),
    "& > *": {
      fontSize: 14,
    },
  },
}));

export const exerciseTagCategoryMultiSelectStyles = makeStyles((theme) => ({
  root: {},
  manageButton: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    fontSize: 14,
    padding: theme.spacing(0.5, 1),
    lineHeight: theme.spacing(2),
  },
  menu: {
    zIndex: "99999 !important" as any,
  },
  primaryLabel: {
    fontSize: 11,
    fontWeight: 500,
    padding: theme.spacing(0.3, 0.8),
    height: 18,
    width: "fit-content",
    marginLeft: theme.spacing(1),
    "&.MuiButton-contained": {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  menuHeader: {
    fontSize: 14,
    fontWeight: 500,
    padding: theme.spacing(0.5, 2),
    pointerEvents: "none",
  },
  menuItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1, 1, 1, 0),
  },
  tagDescription: {
    maxWidth: 265,
    fontSize: 12,
    padding: 0,
    paddingTop: theme.spacing(0.4),
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    lineHeight: 1.4,
  },
  tagOption: {
    padding: theme.spacing(0.7, 2),
    marginLeft: 0,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "row",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
